const { connect } = require('react-redux');
const { context } = require('app-context');
const { push: Push } = require('connected-react-router');

const ResourcesPage = require('../components/ResourcesPage');

const selectors = context.selectors.all;

module.exports = connect(
    (state) => ({
        resources: selectors.getResources(state),
        isLoading: selectors.getIsLoadingResources(state)
    }),
    (dispatch) => ({
        onNavigateToDetail: (resourceId) => dispatch(Push(`/app/resources/${resourceId}?fromList=true`))
    })
)(ResourcesPage);
